interface JsonViewerProps {
  data: any
  title?: string
}

export function JsonViewer({ data, title }: JsonViewerProps) {
  let jsonString: string
  let parsedData: any

  if (typeof data === 'string') {
    // Try to parse if it's a JSON string
    try {
      parsedData = JSON.parse(data)
      jsonString = JSON.stringify(parsedData, null, 2)
    } catch {
      // If parsing fails, treat as plain string
      jsonString = data
    }
  } else {
    jsonString = JSON.stringify(data, null, 2)
  }
  
  // Simple syntax highlighting using regex
  const highlightJson = (json: string): string => {
    return json
      .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
        let cls = 'text-secondary' // default
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'text-blue-400' // key
          } else {
            cls = 'text-green-400' // string value
          }
        } else if (/true|false/.test(match)) {
          cls = 'text-purple-400' // boolean
        } else if (/null/.test(match)) {
          cls = 'text-muted' // null
        } else {
          cls = 'text-yellow-400' // number
        }
        return `<span class="${cls}">${match}</span>`
      })
  }

  return (
    <div>
      {title && (
        <div className="text-xs font-semibold mb-1 text-muted">
          {title}
        </div>
      )}
      <pre className="bg-secondary-bg text-secondary p-2 rounded text-xs overflow-x-auto">
        <code dangerouslySetInnerHTML={{ __html: highlightJson(jsonString) }} />
      </pre>
    </div>
  )
}

